<section>
  <div class="container has-text-centered-mobile">
    <setis-content-header [title]="productType?.title"></setis-content-header>
    <ng-container *ngFor="let product of products$ | async">
      <setis-product-summary [product]="product"></setis-product-summary>
    </ng-container>
  </div>
</section>
